import SideBarLayout from './SideBar';

const Layouts = {
  SideBarLayout,
};

export default Layouts;
